module.exports = __webpack_public_path__ + "img/download.76c86c0b.png";